import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { ModalService } from '../../../../components/modal-list/modal-list.service';
import { ModalContactOurExpertComponent } from '../../misc/contact-our-experts-hidden/modal-contact-our-expert/modal-contact-our-expert.component';

@Component({
  selector: 'contact-our-experts',
  templateUrl: './contact-our-experts.component.html',
  styleUrl: './contact-our-experts.component.scss',
  standalone: false,
})
export class ContactOurExpertsComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = '';

  product$ = this.currentProductService.getProduct([ProductScope.DETAILS, ProductScope.PRICE]);
  // product$: Observable<Product> = this.currentProductService
  //   .getProduct()
  //   .pipe(filter(isNotNullable), distinctUntilChanged());

  constructor(
    private currentProductService: CurrentProductService,
    private modalService: ModalService,
  ) {}

  subscription = new Subscription();

  ngOnInit(): void {
    this.checkProduct();
    // this.openModalContactOurExperts();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkProduct() {
    this.subscription.add(
      this.product$.subscribe(product => {
        this.hostClass = product?.discontinued ? 'd-none product-discontinued' : '';
      }),
    );
  }

  openModalContactOurExperts() {
    this.modalService.create({
      id: 'modal-contact-our-experts',
      title: 'Contact Our Experts',
      width: 1200,
      component: ModalContactOurExpertComponent,
    });
  }
}
